import { ThreeElements } from '@react-three/fiber';
import * as THREE from 'three';
import { ArrowHelper } from '../ArrowHelper';

type AxesHelperProps = ThreeElements['group'] & {
  origin?: THREE.Vector3;
  length?: number;
  shaftRadius?: number;
  headRadius?: number;
  colors?: [string, string, string];
};

export const AxesHelper = ({
  origin = new THREE.Vector3(0, 0, 0),
  length = 1,
  shaftRadius = 0.01,
  headRadius = 0.04,
  colors = ['#ff2060', '#20df80', '#2080ff'], // Default colors for X, Y, Z axes
  ...restProps
}: AxesHelperProps) => {
  return (
    <group position={origin} {...restProps}>
      <ArrowHelper
        origin={new THREE.Vector3(0, 0, 0)}
        direction={new THREE.Vector3(1, 0, 0)}
        length={length}
        shaftRadius={shaftRadius}
        headRadius={headRadius}
        color={colors[0]}
      />
      <ArrowHelper
        origin={new THREE.Vector3(0, 0, 0)}
        direction={new THREE.Vector3(0, 1, 0)}
        length={length}
        shaftRadius={shaftRadius}
        headRadius={headRadius}
        color={colors[1]}
      />
      <ArrowHelper
        origin={new THREE.Vector3(0, 0, 0)}
        direction={new THREE.Vector3(0, 0, 1)}
        length={length}
        shaftRadius={shaftRadius}
        headRadius={headRadius}
        color={colors[2]}
      />
      <mesh>
        <sphereGeometry args={[0.05, 20, 20]} />
        <meshStandardMaterial color={'grey'} />
      </mesh>
    </group>
  );
};
